import { MouseEvent, ReactElement, useState } from 'react';
import { useLoginAction, useUserData } from '@client/context/hooks';
import { ROUTES } from '@client/routes/components/Router/routes';
import { useRouterPush, useUrlCreator } from '@client/routes/hooks';
import { Features } from './Features';
import { Props } from './FeaturesContainer.types';

export const FeaturesContainer = (props: Props): ReactElement => {
  const {
    manufacturerInternalPage,
    stockCount,
    isSellout,
    isOccasion,
  } = props;
  const [isRestockModalOpen, setIsRestockModalOpen] = useState(false);
  const { isLoggedIn } = useUserData();
  const redirectToLogin = useLoginAction();
  const pushAction = useRouterPush();
  const urlCreator = useUrlCreator();
  const manufacturerPageUrl = `${urlCreator(
    ROUTES.manufacturer,
    { manufacturer: manufacturerInternalPage.replace('/', '') },
  )}`;
  const isRestockButtonVisible = isLoggedIn && stockCount < 1 && !isOccasion && !isSellout;

  const handleManufacturerPageClick = (event: MouseEvent<HTMLAnchorElement>): void => {
    event.preventDefault();
    pushAction(manufacturerPageUrl);
  };

  const handleModalOpen = (): void => {
    if (!isLoggedIn) {
      return redirectToLogin();
    }

    setIsRestockModalOpen(true);
  };

  const handleRestockModalClose = () => {
    setIsRestockModalOpen(false);
  };

  return (
    <Features
      {...props}
      onManufacturerPageClick={handleManufacturerPageClick}
      manufacturerPageUrl={manufacturerPageUrl}
      isRestockButtonVisible={isRestockButtonVisible}
      isRestockModalOpen={isRestockModalOpen}
      onRestockModalClose={handleRestockModalClose}
      onRestockModalOpen={handleModalOpen}
      onEmailSend={handleModalOpen}
    />
  );
};
